import type { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import useEnumsData from 'src/hooks/data/use-enums-data'
import type { ISelectOption } from '~/core/ui/Select'
import { TypographyText } from '~/core/ui/Text'
import { showDateTime } from '~/core/utilities/format-date'

import type { INotification, INotificationInterview } from '~/lib/features/notifications/types'

import NotificationItemLayout from './NotificationItemLayout'

const UserCancelInterview: FC<{
  currentTenantName?: string
  notification: INotification
  onClick: () => void
  onDelete: () => void
  isLoadingDeleted: boolean
}> = ({ currentTenantName, notification, onClick, onDelete, isLoadingDeleted }) => {
  const { i18n } = useTranslation()
  const interviewEvents = useEnumsData({
    enumType: 'InterviewEvent',
    locale: i18n.language
  })
  const propertiesRelated = notification?.payload as INotificationInterview

  return (
    <NotificationItemLayout
      onDelete={onDelete}
      isLoadingDeleted={isLoadingDeleted}
      user={notification.user}
      actionType={notification.actionType}
      readAt={notification.readAt}
      createdAt={notification.createdAt}>
      {({ time }) => (
        <>
          <TypographyText
            className="cursor-pointer text-sm text-gray-700"
            onClick={() => {
              onClick && onClick()
            }}>
            <Trans
              i18nKey="activity:notification:userCancelInterview"
              values={{
                userName: notification?.user?.fullName,
                interviewType: interviewEvents.filter(
                  (item: ISelectOption) => item.value === propertiesRelated?.interviewType
                )?.[0]?.supportingObj?.name,
                timeFormatted: showDateTime({
                  start: propertiesRelated?.fromDatetime,
                  end: propertiesRelated?.toDatetime,
                  timezone: propertiesRelated?.timezone
                }),
                profileFullName: propertiesRelated?.profileFullName
              }}>
              <span className="font-medium text-gray-900" />
            </Trans>
            {time}
          </TypographyText>
        </>
      )}
    </NotificationItemLayout>
  )
}

export default UserCancelInterview
